import _Typography from "@material-ui/core/esm/Typography";
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : "" + key, ref: null, props: props, _owner: null }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useIntl } from 'react-intl';
import { Form, messages as formMessages } from '@octopy/react-form';
import { messages } from "./EmailFormMessages";
import { useStyles } from "./EmailFormStyles";

const EmailForm = props => {
  const onSubmit = props.onSubmit;
  const intl = useIntl();
  const classes = useStyles();

  const getInitialValues = initialValues => _objectSpread({
    email: ''
  }, initialValues);

  const getFields = () => [{
    type: 'text',
    name: 'email',
    label: intl.formatMessage(formMessages.emailLabel),
    placeholder: intl.formatMessage(formMessages.emailPlaceholder)
  }];

  const requiredFieldError = intl.formatMessage(formMessages.requiredFieldError);
  const invalidEmailError = intl.formatMessage(formMessages.invalidEmailError);

  const getValidationRules = () => Yup.object({
    email: Yup.string().email(invalidEmailError).required(requiredFieldError)
  });

  const handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (formData) {
      onSubmit && onSubmit(formData);
    });

    return function handleSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return _jsx("div", {
    className: classes.container
  }, void 0, _jsx(_Typography, {
    variant: "subtitle2",
    color: "primary",
    component: "h2",
    className: classes.title
  }, void 0, intl.formatMessage(messages.title)), _jsx(_Typography, {
    variant: "body1",
    className: classes.instructions
  }, void 0, intl.formatMessage(messages.formInstructions)), _jsx(Form, {
    autoFocus: true,
    initialValues: getInitialValues(),
    validationRules: getValidationRules(),
    fields: getFields(),
    buttonSubmitLabel: 'Enviar',
    handleSubmit: handleSubmit
  }));
};

export { EmailForm };